module.exports = __webpack_public_path__ + "photo_spot_international_footer_logo.png?7f85d3b9ad08ed92130a62b8dc6772dd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo_spot_international_footer_logo.png
// module id = 567
// module chunks = 0